(function () {
  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("text-banner-section")) {
      return;
    }

    const setupMinHeight = (section) => {
      if (section.querySelector(".text-banner__heading") != null) {
        const tallest = [
          ...section.querySelectorAll(".text-banner__heading"),
        ].reduce((max, el) => (el.clientHeight > max.clientHeight ? el : max));

        section.style = `--min_height_text-banner: ${tallest.clientHeight}px`;
      }
    };

    const animateHeadings = (section, timeout = 2000) => {
      let headings = section.querySelectorAll(".text-banner__heading");
      if (!headings.length) return;
      let index = 0;
      headings[0].classList.add("active");

      setInterval(() => {
        headings.forEach((h) => h.classList.remove("active"));
        headings[index].classList.add("active");
        index = (index + 1) % headings.length;
      }, timeout);
    };

    const timeout =
      section.querySelector(".text-banner").dataset.timeout * 1000;

    setupMinHeight(section);
    animateHeadings(section, timeout);

    window.addEventListener("resize", () => {
      setTimeout(() => setupMinHeight(section), 500);
    });
  };

  initSectionLayout(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSectionLayout(event.target);
  });
})();
